/**
 * The open file's author chips, next to its name in the editor header (design board "Workspace": "StoreMap.jsx LB
 * AI"): who else is in this file right now, people round (editing or viewing), AI agents square with their driver's
 * initials (writing). Nothing when you are alone in it.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { ParticipantMark } from '../presence/Presence';
import { agentName, presenceAt } from '../../utils/presenceModel';
import './Workspace.css';

export function fileAuthorMarks(snapshot, path) {
  const { people, agents } = presenceAt(snapshot, path);
  return [
    ...people.map(({ person, verb }) => ({ key: `p:${person.id}`, agent: false, initials: person.initials, slot: person.slot, label: `${person.name} ${verb}` })),
    ...agents.map((agent) => ({ key: `a:${agent.id}`, agent: true, initials: agent.driver?.initials || 'AI', slot: agent.slot, paused: Boolean(agent.paused), label: `${agentName(agent, snapshot?.you)} writing` })),
  ];
}

export default function FileAuthorChips({ snapshot, path, max = 3 }) {
  const marks = fileAuthorMarks(snapshot, path);
  if (marks.length === 0) { return null; }
  const label = `Here in this file: ${marks.map((m) => m.label).join(', ')}`;
  return (
    <span aria-label={label} className="file-author-chips" data-testid="file-author-chips" role="group" title={label}>
      {marks.slice(0, max).map((mark) => (
        <ParticipantMark agent={mark.agent} initials={mark.initials} key={mark.key} label={mark.label} paused={mark.paused} size={18} slot={mark.slot} />
      ))}
      {marks.length > max && <span className="file-author-more">+{marks.length - max}</span>}
    </span>
  );
}

FileAuthorChips.propTypes = {
  max: PropTypes.number,
  path: PropTypes.string,
  snapshot: PropTypes.object,
};
